export const isEntryErrorTimeRelated = (error?: string) =>
  error && !['invalid-segment', 'missing-method'].includes(error);

export const shouldDisplayError = (error?: string) =>
  error && !['missing-method'].includes(error);
